import React, { useState, useEffect } from 'react';
import axios from 'axios';
import API_URL from '../api/config';
import { Link, useNavigate, useLocation} from 'react-router-dom';
import '../styles/style.css'; 
import { useQuery } from '@tanstack/react-query';
import { toast, ToastContainer } from 'react-toastify';
import { io } from 'socket.io-client';

import ReactModal from 'react-modal';
import ImageWithLoader2 from '../components/ImageWithLoader2';

import { useFamilyAdmin } from '../hooks/useFamilyAdmin';

const isLocalhost = window.location.hostname === 'localhost';
const SOCKET_URL = isLocalhost ? "http://localhost:8081" : "https://oret.africa";

const socket = io(SOCKET_URL, {
  path: "/tree/mobile/backend/socket.io",
  transports: ["polling", "websocket"],
  withCredentials: true,
  autoConnect: false
});




function Header({ toggleSidebar }) {
    
  const navigate = useNavigate();

  useFamilyAdmin();

  const loggedInUserId = localStorage.getItem("user_id");

  const location = useLocation(); // Get current path

  const [family_code, setFamilyCode] = useState(null);
  
  const [showFamilyModal, setShowFamilyModal] = useState(false);
   const [isSaving, setIsSaving] = useState(false);
  // Load family_code from localStorage
 

    useEffect(() => {
      const family_code = localStorage.getItem('family_code');
      if (family_code) setFamilyCode(family_code);
    }, []);

//notifications
  const [notifications, setNotifications] = useState([]);
const [unreadCount, setUnreadCount] = useState(0);


useEffect(() => {
  if (!family_code) return;

  if (!socket.connected) {
    socket.connect();
  }

  socket.emit("check_pending_family_requests", { family_code });

  const interval = setInterval(() => {
    socket.emit("check_pending_family_requests", { family_code });
  }, 10000);

  socket.on("pending_request_status", (data) => {
    if (data.hasPending && data.count > 0) {
      const newNotif = {
        message:
          data.count === 1
            ? `There is ${data.count} pending family join request`
            : `There are ${data.count} pending family join requests`,
        timestamp: new Date().toLocaleTimeString(),
      };

      setNotifications((prev) => {
        const alreadyExists = prev.some((n) => n.message === newNotif.message);
        return alreadyExists ? prev : [newNotif, ...prev];
      });

      setUnreadCount((prev) => (prev === 0 ? 1 : prev));
    } else {
      setNotifications([]);
      setUnreadCount(0);
    }
  });

  return () => {
    socket.off("pending_request_status");
    clearInterval(interval);
  };
}, [family_code]);

//end of notifications


     // Fetch Family Name
  const { data: familyNameData, isLoading, isError, refetch } = useQuery({
    queryKey: ['familyName'],
    queryFn: () =>
      axios.get(`${API_URL}/family-name-api`, { withCredentials: true })
        .then(res => res.data.family_name?.substring(0, 16) || ""),
    staleTime: 0,
    cacheTime: Infinity,
  });


  // Show modal if no family name, but NOT on family-info-update page   
  useEffect(() => {
    if (
      !isLoading &&
      !isError &&
      (!familyNameData || familyNameData.trim() === "") &&
      location.pathname !== "/family-info-update" &&
      location.pathname !== "/family-info-update-clan" && 
      location.pathname !== "/family-info-update-clan-add" && location.pathname !== "/family-info-update-totem-add"
      && location.pathname !== "/sign-up-category" && location.pathname !== "/sign-up-husband-details" 
      && location.pathname !== "/sign-up-gender"  
    ) {
      setShowFamilyModal(true);
    }
  }, [isLoading, isError, familyNameData, location.pathname]); // add location.pathname

    
       // Fetch User Details
  const { data: user, isLoadingP, isErrorP } = useQuery({
    queryKey: ['userDetails'],
    queryFn: () =>
      axios.get(`${API_URL}/user-details-api`, { withCredentials: true })
        .then(res => res.data),
    staleTime: 0,
    cacheTime: Infinity,
  });



  //fetch popup if invited is 1

  const [showInvitationModal, setShowInvitationModal] = useState(false);

  const {
    data: invitationData,
    isLoading: isLoadingInvitation,
    isError: isErrorInvitation
  } = useQuery({
    queryKey: ['checkInvitation'],
    queryFn: async () => {
      const res = await axios.get(
        `${API_URL}/check-user-invitation-api`,
        { withCredentials: true }
      );
  
      return res.data; // IMPORTANT
    },
    staleTime: 0,
    cacheTime: Infinity,
  });

  // Show modal if invited is 1, but NOT on these pages  
  useEffect(() => {
    if (
      !isLoadingInvitation &&
      !isErrorInvitation &&
      invitationData?.invited === 1 && // SHOW only if invited === 1
      location.pathname !== "/verify-invitation-info-update" &&
      location.pathname !== "/verify-invitation-info-confirm" &&
      location.pathname !== "/verify-invitation-reject" 
    ) {
      setShowInvitationModal(true);
    } else {
      setShowInvitationModal(false);
    }
  
  }, [
    isLoadingInvitation,
    isErrorInvitation,
    invitationData,
    location.pathname
  ]);


  


  
  const handleUpdateDetails = () => {

    //if (isSaving) return; // prevent double click
    setIsSaving(true);
  
    axios.post(
      `${API_URL}/update-family-info-details-api`,
      {},
      { withCredentials: true }
    )
      .then((res) => {
        if (res.data.Status === "Success") {
          navigate(res.data.redirect);
        }
      })
      .catch(() => {
        toast.error("Failed to update");
      })
      .finally(() => setIsSaving(false));
  };

 
      
      // Fetch Chat Members with Unread Count
  const { data: chatList = [] } = useQuery({
    queryKey: ['chat-members-list'],
    queryFn: () => axios.get(`${API_URL}/chat-members-list`).then(res => res.data),
    staleTime: 5000,
    refetchInterval: 5000, // Optional: for live update
  });

  const totalUnread = Array.isArray(chatList)
  ? chatList.reduce((acc, curr) => acc + (curr.unread_count || 0), 0)
  : 0;
  
  const [showNotif, setShowNotif] = useState(false);
  const [showMsg, setShowMsg] = useState(false);

  return (
      <>
           {/* Missing family name modal */}

          

           <ReactModal
             isOpen={showFamilyModal}
             onRequestClose={() => setShowFamilyModal(false)}
             shouldCloseOnOverlayClick={false} // prevent closing without selection
      shouldCloseOnEsc={false}
             className="Modal family-update-modal"
             overlayClassName="Overlay Overlay--blur"
           >
             <div className="family-update-card">
               <div className="family-update-icon">
                 <i className="bi bi-info-circle"></i>
               </div>
               <h5 className="family-update-title">Update Family Info</h5>
               <p className="family-update-sub">
                 Your family info is not set. Please update it to continue.
               </p>

               <button
                 className="btn family-update-btn"
                 onClick={handleUpdateDetails}
                 disabled={isSaving}
               >
                {isSaving ? "Loading..." : "Update Now"}
                 
               </button>

               {/*<button
                 className="btn family-update-btn"
                 onClick={() => {
                   setShowFamilyModal(false);
                   navigate('/family-info-update');
                 }}
               >
                 Update Now
               </button>*/}
             </div>
           </ReactModal>
     
           {/* Sticky Header */}



           <ReactModal
             isOpen={showInvitationModal}

             ariaHideApp={false}
  shouldCloseOnOverlayClick={false}
  shouldCloseOnEsc={false}
  onRequestClose={() => {}}

             
             className="Modal family-update-modal"
             overlayClassName="Overlay Overlay--blur"
           >
             <div className="family-update-card">
               <div className="family-update-icon">
                 <i className="bi bi-info-circle"></i>
               </div>
               <h5 className="family-update-title">Confirm your invitation info</h5>
               <p className="family-update-sub">
                 Your details info is not set. Please update it to continue.
               </p>
               <button
                 className="btn family-update-btn"
                 onClick={() => {
                  setShowInvitationModal(false);
                   navigate('/verify-invitation-info-update');
                 }}
               >
                 Update Now
               </button>
             </div>
           </ReactModal>

           

          
           <header className="appHeader">
             {/* LEFT: logo */}
             <button className="appHeader__brandBtn" onClick={toggleSidebar} aria-label="Open sidebar">
               <img
                 src={`${process.env.PUBLIC_URL}/img/logo_11.png`}
                 alt=""
                 className="appHeader__brandImg"
               />
             </button>
     
             {/* CENTER: title */}
             <div className="appHeader__title" title={familyNameData || ''}>
               {isLoading ? (
                 <span>Loading…</span>
               ) : isError ? (
                 <span>Family name here…</span>
               ) : (
                 <span>{familyNameData || 'No family name'}</span>
               )}
             </div>
     
             {/* RIGHT: icons */}
             <div className="appHeader__right">
               {/* Notifications */}
               <div className="appHeader__dropdown">
                 <button
                   className="appHeader__iconBtn"
                   onClick={() => {
                     setShowNotif((s) => !s);
                     setShowMsg(false);
                   }}
                   aria-label="Notifications"
                 >
                   <i className="fas fa-bell" />
                   {unreadCount > 0 && (
                     <span className="appHeader__badge appHeader__badge--amber">{unreadCount}</span>
                   )}
                 </button>
     
                 {showNotif && (
                   <div className="appHeader__menu">
                     <h6 className="appHeader__menuTitle">Notifications</h6>
                     <div className="appHeader__menuBody">
                       {notifications.length === 0 ? (
                         <p className="appHeader__empty">No notifications yet</p>
                       ) : (
                         notifications.map((n, i) => (
                           <Link to="/family-requests" key={i} className="appHeader__menuItem">
                             <p className="mb-0">{n.message}</p>
                             <small className="text-muted">{n.timestamp}</small>
                           </Link>
                         ))
                       )}
                     </div>
                   </div>
                 )}
               </div>
     
               {/* Messages */}
               <div className="appHeader__dropdown">
                 <button
                   className="appHeader__iconBtn"
                   onClick={() => {
                     setShowMsg((s) => !s);
                     setShowNotif(false);
                   }}
                   aria-label="Messages"
                 >
                   <i className="fas fa-envelope" />
                   {totalUnread > 0 && (
                     <span className="appHeader__badge appHeader__badge--green">{totalUnread}</span>
                   )}
                 </button>
     
                 {showMsg && (
                   <div className="appHeader__menu">
                     <h6 className="appHeader__menuTitle">Messages</h6>
                     {chatList.some((c) => c.unread_count > 0) ? (
                       chatList
                         .filter((c) => c.unread_count > 0)
                         .map((c) => (
                           <button
                             key={c.user_id}
                             className="appHeader__menuItemBtn"
                             onClick={() => navigate('/chat', { state: { receiverId: c.user_id } })}
                           >
                             <ImageWithLoader2
                               src={c.image_url}
                               placeholder="https://oret.africa/tree/img/placeholder-human-icon.jpg"
                               fadeDuration={800}
                               blurAmount={15}
                               alt={c.name}
                               className="rounded-circle me-2"
                               style={{ width: 35, height: 35, objectFit: 'cover' }}
                             />
                             <div className="flex-grow-1">
                               <strong>
                                 {c.n_prefix} {c.name} {c.last_name}
                               </strong>
                               <p className="mb-0 small text-truncate">
                                {/*{c.last_message || 'New message'}*/}

                                {c.last_message
                                    ? c.last_message.length > 35
                                      ? c.last_message.slice(0, 35) + "..."
                                      : c.last_message
                                    : "New message"}
    
                                </p>
                             </div>
                             <span className="appHeader__pill">{c.unread_count}</span>
                           </button>
                         ))
                     ) : (
                       <p className="appHeader__empty">No new messages</p>
                     )}
                   </div>
                 )}
               </div>
             </div>
           </header>
           
<style>{`



.appHeader {
  position: sticky;
  top: 0;
  z-index: 1000;
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  gap: 8px;
  height: 78px; /* slightly taller */
  padding: 0 16px;
  color: #fff;
  background: #184A2C; /* solid dark green */
  border-bottom-left-radius: 24px;
  border-bottom-right-radius: 24px;
  margin-bottom: -60px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);

   
}

.appHeader__brandBtn {
  border: 0;
  background: transparent;
  padding: 0;
  display: flex;
  align-items: center;
}

.appHeader__brandImg {
  height: 28px;
  display: block;
}

.appHeader__title {
  justify-self: center;
  text-align: center;
  font-weight: 700;
  font-size: 20px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 52vw;
  pointer-events: none;
}

.appHeader__right {
  display: flex;
  align-items: center;
  gap: 10px;
  justify-self: end;
}

.appHeader__iconBtn {
  position: relative;
  border: 0;
  background: transparent;
  color: #fff;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s ease;
}

.appHeader__iconBtn:hover {
  background: rgba(255, 255, 255, 0.15);
}

.appHeader__iconBtn i {
  font-size: 18px;
}

.appHeader__badge {
  position: absolute;
  top: -2px;
  right: -2px;
  min-width: 18px;
  height: 18px;
  padding: 0 4px;
  border-radius: 9px;
  font-size: 11px;
  font-weight: 800;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #111;
}

.appHeader__badge--green {
  background: #b8e6c1;
  color: #0f5132;
}

.appHeader__badge--amber {
  background: #f6d58c;
  color: #5e3b00;
}

.appHeader__dropdown {
  position: relative;
}

.appHeader__menu {
  position: absolute;
  right: 0;
  top: 44px;
  min-width: 260px;
  max-height: 260px;
  overflow: auto;
  background: #fff;
  color: #111;
  border-radius: 12px;
  padding: 8px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
}

.appHeader__menuTitle {
  font-weight: 700;
  padding: 6px 8px 10px 8px;
  margin: 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

.appHeader__menuBody {
  padding: 8px;
}

.appHeader__empty {
  padding: 8px;
  margin: 0;
  color: #6b7280;
  font-size: 14px;
}

.appHeader__menuItem {
  display: block;
  padding: 8px;
  border-radius: 8px;
  color: inherit;
  text-decoration: none;
}

.appHeader__menuItem:hover {
  background: #f5f7f9;
}

.appHeader__menuItemBtn {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px;
  border: 0;
  background: transparent;
  text-align: left;
  border-radius: 8px;
}

.appHeader__menuItemBtn:hover {
  background: #f5f7f9;
}

.appHeader__pill {
  background: #ef4444;
  color: #fff;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 800;
  padding: 2px 8px;
}

      `}</style>
    </>
  );
}

export default Header;
